import { defineStore } from 'pinia';
import { useStorage }  from '@vueuse/core';
import dayjs           from 'dayjs';
import i18n            from '@/lang';
import fr              from 'dayjs/locale/fr';
import { setLocale }   from 'yup';

export const useLanguageStore = defineStore('language', {
  state   : () => ({
    language : useStorage('lang', 'en')
  }),
  actions : {
    setLanguage(language) {

      this.language = language;
      i18n.global.locale = this.language;
      dayjs.locale(this.language === 'fr' ? fr : 'en');
      setLocale({
        mixed : {
          required : field => {

            return i18n.global.messages[i18n.global.locale].main.messages.requiredError.replace('{field}', field.label);
          }
        }
      });
    }
  }
});
